import { Calculation } from "./calculation"
import { Group, GroupProps } from "./group"

export class ComparisonNew {
  private group: Group
  private calculation: Calculation

  constructor(group: Group, calculation: Calculation) {
    this.group = group
    this.calculation = calculation
  }

  getComparison() {
    return this
  }

  static getComparisonParameters(
    group: string,
    calculation: string,
    customGroups: GroupProps[] = []
  ) {
    const newGroup = new Group(group, customGroups)
    const newCalculation = new Calculation(calculation)
    return new ComparisonNew(newGroup, newCalculation)
  }

  getGroup() {
    return this.group.getGroup()
  }

  getGroupName(isFund: boolean) {
    return this.group.getGroupName(isFund)
  }

  getGroupNameByKey(key: string, isFund: boolean) {
    return this.group.getGroupNameByKey(isFund, key)
  }

  getComparisonGroup() {
    return this.group
  }

  getComparisonCalculation() {
    return this.calculation
  }

  getGroups(isFund: boolean) {
    return this.group.getGroups(isFund)
  }

  getCustomGroups() {
    return this.group.getCustomGroups()
  }

  isPeers() {
    return this.group.isPeers()
  }

  isAll() {
    return this.group.isAll()
  }

  isTop10() {
    return this.group.isTop10()
  }

  isCustomList() {
    return this.group.isCustomGroup()
  }

  getCalculation() {
    return this.calculation.calculation()
  }

  setGroup(groupName: string, customList: GroupProps[] = []) {
    this.group = new Group(groupName, customList)
  }

  setCustomGroups(customLists: GroupProps[]) {
    this.group.setCustomGroups(customLists)
  }

  setCalculation(calculation: string) {
    this.calculation = new Calculation(calculation)
  }

  equals(other: ComparisonNew) {
    return (
      other !== null &&
      this.group.getGroup() == other.group.getGroup() &&
      this.calculation.getCalcInfo("name") ==
        other.calculation.getCalcInfo("name")
    )
  }

  toString() {
    return `Group: ${this.getGroup()} - Calculation: (${this.getCalculation()})`
  }
}

export namespace ComparisonNew {
  export const PEERS = "peers"
  export const ALL = "all"
  export const TOP10 = "top10"
}
